<template>
  <b-alert
    variant="warning"
    v-if="!isEnable"
    dismissible
    fade
    :show="!isHide"
    @dismissed="isHide = true"
  >
    <div class="alert-body text-center">
      {{ $t('enable_conversation_summary_alert') }}
      <b-link
        class="link-underline text-primary"
        @click="redirect"
        v-if="!loading"
      >
        {{ $t('click_here') }}
      </b-link>
      <b-spinner small v-else></b-spinner>
    </div>
  </b-alert>
</template>

<script>
  import { BAlert, BLink, BSpinner } from 'bootstrap-vue';
  import Repository from '@/repositories/RepositoryFactory';
  import useJwt from '@/auth/jwt/useJwt';

  const MerchantRepository = Repository.get('merchant');
  export default {
    components: {
      BAlert,
      BLink,
      BSpinner
    },
    computed: {
      userData: function () {
        return this.$store.state.profile?.email || this.$store.state.profile?.phone
          ? this.$store.state.profile
          : JSON.parse(
              localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
            );
      },
    },
    data() {
      return {
        loading: false,
        isHide: false,
        isEnable: false
      };
    },
    methods: {
      async getMerchant() {
        try {
          const response = await MerchantRepository.show();
          const { data } = response.data;
          this.isEnable = data.isEnableTopicSummary || false;
        } catch (err) {
          const { data } = err.response;
          const { message } = data;
          if (message === 'error.recordNotFound') await this.createAssignment();
        }
      },
      redirect() {
        this.$router.push({ name: 'chat-settings', query: { tab: 'summary' } });
      }
    },
    created() {
      this.getMerchant();
    }
  };
</script>
